import script from "./ProductSafetyInformations.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSafetyInformations.vue?vue&type=script&setup=true&lang=js"

import "./ProductSafetyInformations.vue?vue&type=style&index=0&id=3d1f9d66&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d1f9d66"]])

export default __exports__